@if (computedSettings && displayData) {
  <ng-multiselect-dropdown
    [settings]="computedSettings"
    [placeholder]="placeholder | translate"
    [data]="displayData"
    [ngModel]="model"
    (ngModelChange)="change($event)"
    (onSelect)="onSelect.emit($event)"
    (onSelectAll)="onSelectAll.emit($event)"
    (onDeSelect)="onDeselect.emit($event)"
    (onDeSelectAll)="onDeselectAll.emit($event)"
    (onFilterChange)="onFilterChange.emit($event)"
    (onDropDownClose)="onDropDownClose.emit($event)"
    (click)="onClick.emit()"
    [ngClass]="{'multiselect-all-selected' : allSelected(), 'multiselect-show-count': showCountLabel()}"
    [disabled]="disabled"
    #multiSelect>
  </ng-multiselect-dropdown>
}
